export enum StoreTypesEnum {
  setMenus = 'app/setMenus',
  setUserInfo = 'user/setUserInfo',
}
